import PreView from './previewImage';

document.addEventListener('turbolinks:load', () => {
  const form = $('form');
  let isClick = false

  $('.feedback-buttons').on('click', '.btn', (e) => {
    const isUp = e.target.getAttribute('data-up');
    const id = e.target.getAttribute('data-id');
    const query = isUp === 'true' ? '?up=1' : ''
    if(isClick) return;
    isClick = true;
    $.post(`/topics/${id}/feedback${query}`, () => {
      $(`.feedback-buttons .btn[data-up=${isUp}]`).addClass('active')
    })
  });
  if (!document.body.className.includes('page-feedbacks') || form.length < 1) {
    return;
  }

  App.createImageUploader(document.querySelector('form'));

  window.preview = new PreView();

  // 删除
  $('body').on('click', '.image-item .btn-del', (e) => {
    const { parentNode } = e.target;
    const id = parentNode.querySelector('img').getAttribute('data-id');
    const inputEle = $(`input[data-id=${id}]`);
    parentNode && parentNode.remove();
    inputEle && inputEle.remove();
  });
});
